/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TrendWeekly.vue?vue&type=template&id=5f118258&scoped=true&"
import script from "./TrendWeekly.vue?vue&type=script&lang=js&"
export * from "./TrendWeekly.vue?vue&type=script&lang=js&"
import style0 from "./TrendWeekly.vue?vue&type=style&index=0&id=5f118258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f118258",
  null
  
)

export default component.exports